import { useMemo } from "react";
import styled from "styled-components";

import { useDialog } from "~/src/modules/ui-kit";

import Finder from "../../../../../modules/finder";
import { BIMClass, Parameter, bimClassSearch, parameterSearch } from "../../../../../modules/shared-entities";
import Back from "../../../components/Back";
import Button from "../../../components/Button";
import SearchBait from "../../../components/SearchBait";
import Unselect from "../../../components/Unselect";
import useSearchKeybind from "../../../components/useSearchKeybind";
import List from "../List";


const StyledList = styled.div`
    align-self: stretch;
    display: flex;
    flex-direction: column;
    gap: 16px;

    &:not(:has(ul)) {
        display: none;
    }
`;

const Title = styled.span`
    color: #fff;
    font-family: var(--font-mono), monospace;
    font-size: .8rem;
`;

function Selector(props) {
    const { bimClassID, onSelectBIMClass, onSelectParameter, parameterID } = props;

    const [Dialog, open, close] = useDialog();
    useSearchKeybind(open);

    const modules = useMemo(
        () => {
            const modules = [];
            if (!parameterID) modules.push(parameterSearch);
            if (!bimClassID) modules.push(bimClassSearch);
            return modules;
        },
        [parameterID, bimClassID],
    );

    function onSelect(name, id) {
        if (name === "BIMClass") onSelectBIMClass(id);
        if (name === "Parameter") onSelectParameter(id);
        close();
    }

    return (
        <>
            <SearchBait>
                <span>
                    { (!bimClassID && !parameterID) && "start by selecting parameter or bimclass" }
                    { (bimClassID && !parameterID) && "you must select a parameter" }
                    { (!bimClassID && parameterID) && "you may also select a bimclass" }
                </span>
                <input
                    onFocus={ open }
                    placeholder="Search"
                />
                <span>find { modules.map((module) => module.name.toLowerCase()).join(" and ") }</span>
                <span>press <i>/</i> or start typing to search</span>
            </SearchBait>
            <Dialog>
                <Finder
                    modules={ modules }
                    onSelect={ onSelect }
                    placeholder="Search"
                />
            </Dialog>
        </>
    );
}

export default function Selection(props) {
    const { bimClassID, parameterID } = props;
    return (
        <>
            <Back to=".." />
            <header>
                <Parameter
                    id={ parameterID }
                    onClick={ () => props.setParameterID(undefined) }
                >
                    <Unselect />
                </Parameter>
                <BIMClass
                    id={ bimClassID }
                    onClick={ () => props.setBIMClassID(undefined) }
                >
                    <Unselect />
                </BIMClass>
            </header>
            {
                (!bimClassID || !parameterID) && (
                    <Selector
                        bimClassID={ bimClassID }
                        onSelectBIMClass={ props.setBIMClassID }
                        onSelectParameter={ props.setParameterID }
                        parameterID={ parameterID }
                    />
                )
            }
            <footer>
                <span />
                <Button
                    disabled={ parameterID === undefined }
                    onClick={ props.next }
                    size="medium"
                >
                    continue
                </Button>
            </footer>
            {
                (bimClassID || parameterID) && (
                    <>
                        <StyledList>
                            <Title>related parameter templates</Title>
                            <List
                                parameterID={ parameterID }
                                bimClassID={ bimClassID }
                            />
                        </StyledList>
                    </>
                )
            }
        </>
    );
}
